import {
  TEXT_COLOR,
  FONT_SIZE_SMALL,
  FONT_WEIGHT_BOLD,
  DROP_SHADOW_MIDDLE,
} from '@/assets/scss/variables.module.scss'

/**
 * ツールチップのエレメントを取得する(無ければ作成する)
 * @param {*} chart チャートオブジェクト
 * @returns {Element} ツールチップのルートエレメント
 */
const getOrCreateTooltip = (chart) => {
  let tooltipEl = chart.canvas.parentNode.querySelector('div')

  if (!tooltipEl) {
    tooltipEl = document.createElement('div')
    tooltipEl.style.width = 'max-content'
    tooltipEl.style.background = '#ffffff'
    tooltipEl.style.borderRadius = '4px'
    tooltipEl.style.opacity = 1
    tooltipEl.style.pointerEvents = 'none'
    tooltipEl.style.position = 'absolute'
    tooltipEl.style.boxShadow = DROP_SHADOW_MIDDLE
    tooltipEl.style.transition = 'opacity 0.2s ease'

    chart.canvas.parentNode.appendChild(tooltipEl)
  }

  return tooltipEl
}

/**
 * ツールチップのオフセット値(px)を取得する
 * @param {string} align 揃え方向(left, right, top, bottom, center)
 * @returns {number} オフセット値(px)
 */
const getTooltipOffset = (align) => {
  switch (align) {
    case 'left':
      return 8
    case 'right':
      return -4
    case 'top':
      return -4
    case 'bottom':
      return 8
    default:
      return 0
  }
}

export default {
  enabled: false,
  callbacks: {
    title: () => '', // タイトル非表示
    label: (context) => {
      // 3段にするために配列化
      return [
        context.label, // X値(時刻)
        context.dataset.label, // 系列名
        context.formattedValue, // Y値
      ]
    },
  },
  external: (context) => {
    // Tooltip Element
    const { chart, tooltip } = context
    const tooltipEl = getOrCreateTooltip(chart)

    // Hide if no tooltip
    if (tooltip.opacity === 0) {
      tooltipEl.style.opacity = 0
      return
    }
    if (!tooltip.dataPoints.length || !tooltip.dataPoints[0].label) {
      tooltipEl.style.opacity = 0
      return
    }

    // Set texts
    if (tooltip.body && tooltip.body.length) {
      // 複数データの並び設定
      tooltipEl.style.display = 'flex'
      tooltipEl.style.flexDirection = 'column'
      tooltipEl.style.justifyContent = 'flex-start'
      tooltipEl.style.alignItems = 'flex-start'
      tooltipEl.style.flexWrap = 'nowrap'
      tooltipEl.style.rowGap = '8px'

      while (tooltipEl.firstChild) {
        tooltipEl.firstChild.remove()
      }

      for (const item of tooltip.body) {
        const container = document.createElement('div')
        // 各行の並び設定
        container.style.display = 'flex'
        container.style.flexDirection = 'column'
        container.style.justifyContent = 'flex-start'
        container.style.alignItems = 'flex-start'
        container.style.flexWrap = 'nowrap'
        container.style.rowGap = '4px'

        item.lines.forEach((line, index) => {
          const text = document.createElement('span')
          text.innerText = line
          text.style.display = 'block'
          text.style.color = TEXT_COLOR
          text.style.fontSize = FONT_SIZE_SMALL
          text.style.lineHeight = 1
          if (index === item.lines.length - 1) {
            text.style.fontWeight = FONT_WEIGHT_BOLD
          }
          container.appendChild(text)
        })

        tooltipEl.appendChild(container)
      }
    }

    // Display position
    tooltipEl.style.opacity = 1
    tooltipEl.style.left = tooltip.x + getTooltipOffset(tooltip.xAlign) + 'px'
    tooltipEl.style.top = tooltip.y + getTooltipOffset(tooltip.yAlign) + 'px'
    tooltipEl.style.font = tooltip.options.bodyFont.string
    tooltipEl.style.padding =
      tooltip.options.padding + 'px ' + tooltip.options.padding + 'px'
  },
}
